import { render } from "./AddPortfolioModal.vue?vue&type=template&id=7bd62d04&ts=true"
import script from "./AddPortfolioModal.vue?vue&type=script&lang=ts"
export * from "./AddPortfolioModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__